import { TeButton, TeContainer, TeContainerSlim, TeImage, TeText } from '@topcon/tuicl-react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { background } from '../../providers/theme/theme.index';
import { AppBody } from '../../api/generated/pap';

interface Props {
  apps: AppBody[];
}

function RenderApps({ apps }: Props) {
  const { t } = useTranslation(['apps', 'profile']);
  const openApp = (url: string) => window.open(url, '_blank');

  return (
    <>
      {apps &&
        apps.map((app) => {
          return (
            <TeContainer
              key={app.id}
              grow
              borderRadius={8}
              backgroundColor="background.tertiary"
              alignItems="center"
            >
              {/* TODO: Add app icon */}
              <StyledTeImage imageSource={app.iconURL} />
              <TeContainerSlim column gap="xs2" grow>
                <TeContainerSlim gap="xs" alignItems="center">
                  <TeText size={16} weight={700}>
                    {app.name}
                  </TeText>
                  {/* TODO: Add app type */}
                </TeContainerSlim>
                <TeText color="text.secondary">{app.description}</TeText>
              </TeContainerSlim>
              <TeContainerSlim gap="l" alignItems="center">
                {/* TODO: Add app release notes */}
                {/* TODO: Add app version */}
                {/* <TeContainerSlim gap="xs2">
                  <TeText size={12} color="text.link">
                    {t('viewReleaseNotes')}
                  </TeText>
                  <TeText size={12} color="text.secondary">
                    {t('version', { version: 'MISSING' })}
                  </TeText>
                </TeContainerSlim> */}
                <TeButton
                  variant="neutral"
                  size="s"
                  text={t('launchApp')}
                  teclick={() => openApp(app.homepageURL)}
                />
              </TeContainerSlim>
            </TeContainer>
          );
        })}
    </>
  );
}

export default RenderApps;

const StyledTeImage = styled(TeImage)`
  width: 48px;
  height: 48px;
  background-color: ${background.brand.primary};
  border-radius: 12px;
  display: flex;
`;
